<div
  class="wrapper"
  (mouseenter)="isMenuOpen = true"
  (mouseleave)="isMenuOpen = false"
>
  <div class="hover-zone" *ngIf="isMenuOpen"></div>

  <button
    #btnTrigger
    mat-button
    tourAnchor="nova-cotacao-btn"
    class="wrapper-trigger"
    [ngClass]="{
      'tour-pulse': tourStepsService.currentAnchor() === 'nova-cotacao-btn'
    }"
    *showIfAuthorized="'BOTAO_NOVA_COTACAO'"
    data-testid="btn_nova-cotacao"
  >
    <span class="wrapper-trigger__content">
      Nova Cotação
      <ng-icon name="heroChevronDown"></ng-icon>
    </span>
  </button>

  <div #menu class="wrapper-menu" *ngIf="isMenuOpen">
    <ul class="wrapper-menu__list">
      <ng-container *ngFor="let item of menuCotacaoComputed()">
        <li
          *showIfAuthorized="item.showIfAuthorizedName"
          class="wrapper-menu__item"
        >
          <div class="h-6 flex items-center gap-2 font-semibold">
            <span class="wrapper-menu__title">{{ item.titulo }}</span>
            @if(item.trial) {
              <div class="rounded-2xl text-nowrap py-1 px-2 border flex items-center gap-2 bg-[#F3F4F6]"> 
                <ng-icon name="heroGiftMini" size="20px" class="text-text-interactive"></ng-icon>
                <span>Periodo de teste</span>
              </div>
            }
           </div>
          <ul class="wrapper-menu__submenu">
            <ng-container *ngFor="let subItem of item.list">
              <a
                [routerLink]="subItem.url"
                [queryParams]="queryParams()"
                class="wrapper-menu__submenu-item"
                (click)="openPage()"
                *showIfAuthorized="subItem.showIfAuthorizedName"
                gaEvent="ID_HEAD_NOVA_COTACAO"
                [attr.data-testid]="'link_' + subItem.txt.toLowerCase().replace(' ', '-')"
              >
                <ng-icon [name]="subItem.icone"></ng-icon>
                <span>{{ subItem.txt }}</span>
              </a>
            </ng-container>
          </ul>
        </li>
      </ng-container>
      @if (isSaudeCTAVisible) {
        <menu-item-saude></menu-item-saude>
      }
    </ul>
  </div>
</div>
